// extracted by mini-css-extract-plugin
export default {"notificationMenu":"Notification_notificationMenu__+e7Qw","notificationCard":"Notification_notificationCard__VN4b4"};